<template>
    <section class="content">
        <div class="card card-primary">
            <div class="card-header">
                <h3 class="card-title">Form Data</h3>
            </div>
            <!-- /.card-header -->
            <!-- form start -->
            <form role="form" @submit="submitForm">
                <div class="card-body">
                    <p v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </p>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <label class="control-label">Skenario Jurnal</label>
                            <select v-model="form.skenario" class="form-control">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="16">16</option>
                            </select>
                        </div>
                        <div class="col-md-6 form-group">
                            <label class="control-label">Kode</label>
                            <input type="text" class="form-control" v-model="form.id">
                        </div>
                    </div>
                </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <button type="button" class="btn btn-secondary" v-on:click="submitForm">Test</button>                    
                        </div>
            </form>
        </div>
    </section>
    <!-- /.content -->
</template>
<script>
import { authFetch } from '@/libs/hxcore';
export default {
    name: 'Test',
    data() {
        return {
            errors: [],
            countries: [{label: 'Canada', code: 'ca'}, {label: 'Indonesia', code: 'id'}],
            form: {
                name: '',
                opt1:'',
                username: '',
            }
        }
    },
    components: {
    },
    mounted() {
        
    },
    methods: {
        submitForm: function(e) {
            //if (this.form.name && this.form.username) {
                var data = Object.keys(this.form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.form[key])).join('&')

                authFetch('/examples/test', {
                        method: 'POST',
                        body: data
                    })
                    .then(res => {
                        if (res.status === 201) {
                            alert('OK');
                        } else if (res.status === 400) {
                            //let errorResponse = await res.json();
                            //this.errors.push(errorResponse.error);
                        }
                        return res.json();
                    })
                    .then(js => {
                        alert(js.success)
                    });
            //}
            this.errors = [];
            e.preventDefault();
        },
    }
}
</script>
<style>
.twitter-typeahead {
    display: block !important;
}
</style>